import { QuestionCard } from "./QuestionCard";

export const FAQPage = () => {
  const faqs = [
    {
      question: "質問テキスト質問テキスト質問テキスト質問テキスト質問テキスト質問テキスト",
      answer:
        "答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト",
    },
    {
      question: "質問テキスト質問テキスト質問テキスト質問テキスト質問テキスト質問テキスト",
      answer:
        "答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト",
    },
    {
      question: "質問テキスト質問テキスト質問テキスト質問テキスト質問テキスト質問テキスト",
      answer:
        "答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト",
    },
    {
      question: "質問テキスト質問テキスト質問テキスト質問テキスト質問テキスト質問テキスト",
      answer:
        "答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト答えテキスト",
    },
  ];

  return (
    <div className="bg-white min-w-full min-h-screen">
      <div className="p-[18px] flex flex-col items-start gap-5">
        <div className="flex flex-col items-start gap-3 w-full">
          <div className="flex items-center gap-3">
            <p className="text-xl font-bold -tarcking-[.01em] text-black">FAQ</p>
          </div>
        </div>

        <div className="flex flex-col gap-5 w-full">
          {faqs.map((faq, index) => {
            return <QuestionCard key={index} content={faq} index={index + 1} />;
          })}
        </div>
      </div>
    </div>
  );
};
